// El contenido de la landing, tal como viene en el diseño (polz-rediseno). Es un
// sitio estático: no hay API ni base detrás.
export const ASSETS = '/static/polz';
export const RAIZ = '/landing-polz';
export const URL_PROYECTOS = `${RAIZ}/proyectos`;

export const CORREO = 'info@polzasociados.cl';
export const TELEFONO = '+56 2 2985 1046';
export const TELEFONO_HREF = 'tel:+56229851046';
export const DIRECCION = 'Polz Asociados · Badajoz 100 of. 107, Las Condes, Santiago.';

export const foto = (id, ancho, calidad = 80) =>
  `https://images.unsplash.com/${id}?auto=format&fit=crop&w=${ancho}&q=${calidad}`;
export const respaldo = (nombre) => `${ASSETS}/${nombre}.svg`;
export const urlFicha = (slug) => `${RAIZ}/${slug}`;
export const correo = (asunto) => `mailto:${CORREO}${asunto ? `?subject=${encodeURIComponent(asunto)}` : ''}`;

// Si la foto de Unsplash no carga, queda el gráfico de respaldo del diseño.
export function conRespaldo(evento, nombre) {
  const img = evento.target;
  img.onerror = null;
  img.src = respaldo(nombre);
}

export const REGIONES = ['Coquimbo', 'Maule', 'Biobío', 'Los Lagos', 'Metropolitana'];

const DISCLAIMER =
  'Antecedentes extraídos de la ficha pública histórica. No indican la situación ni la disponibilidad comercial vigente.';
const CONCEPTUAL =
  'El gráfico es conceptual y no señala una ubicación geográfica exacta del predio. Se recomienda reemplazarlo por cartografía oficial y coordenadas verificadas por Polz Asociados.';

export const PROYECTOS = [
  {
    slug: 'lomas-de-lambert',
    nombre: 'Lomas de Lambert',
    titulo: 'Lomas de <em>Lambert.</em>',
    tipo: 'Parcelas / Loteo habitacional',
    ciudad: 'La Serena',
    region: 'Coquimbo',
    regionNombre: 'Región de Coquimbo',
    foto: 'photo-1500534623283-312aade485b7',
    respaldo: 'coquimbo',
    alt: 'Imagen paisajística referencial de colinas',
    sello: 'https://www.polzasociados.cl/wp-content/uploads/2017/10/logo-265x265.png',
    selloRespaldo: 'lomas-logo',
    descripcion: '«El descanso del minero». Parcelas próximas al pueblo de Lambert, a 22 kilómetros de La Serena.',
    stats: ['Más de 200 parcelas', '5.000–7.000 m²'],
    busqueda: 'la serena lomas de lambert el descanso del minero coquimbo parcelas',
    heroAmplio: true,
    lema: 'El descanso del minero',
    subtitulo: 'Un proyecto de loteo habitacional que conecta la tranquilidad del entorno rural con la cercanía a La Serena, junto al pueblo histórico de Lambert.',
    accion: { texto: 'Ver galería', href: '#galeria' },
    identidad: {
      nota: 'El descanso del minero · Identidad del proyecto',
      etiqueta: 'Ficha de desarrollo',
      texto: 'El proyecto se ubica junto al pueblo de Lambert, en el entorno de La Serena, Región de Coquimbo.',
      stats: [
        { valor: '200+', texto: 'Parcelas según ficha original' },
        { valor: '22 km', texto: 'Distancia publicada a La Serena' },
      ],
    },
    titular: 'Un entorno para <span>vivir con tranquilidad</span> y conexión territorial.',
    kicker: null,
    parrafos: [
      'El loteo habitacional <strong>“Lomas de Lambert – El descanso del Minero”</strong> está conformado, según la ficha publicada por Polz Asociados, por más de 200 parcelas con superficies que van desde 5.000 hasta 7.000 m² cada una.',
      'El proyecto se sitúa a solo 22 kilómetros de La Serena, junto al pueblo minero de Lambert. Su emplazamiento se plantea para quienes buscan paz y tranquilidad, sin alejarse de la ciudad.',
      'El sitio original destaca el acceso por camino pavimentado y la existencia de servicios locales en el poblado, entre ellos posta, almacenes, colegio e iglesias. La descripción también menciona la actividad agrícola del valle y las áreas verdes que caracterizan su entorno.',
    ],
    nota: null,
    cifras: [
      { valor: '200+', texto: 'Parcelas según la descripción original' },
      { valor: '5.000–7.000', texto: 'Metros cuadrados por parcela' },
      { valor: '22 km', texto: 'A La Serena, según la ficha original' },
    ],
    secciones: ['galeria', 'atributos', 'ubicacion', 'video'],
    galeria: {
      modo: 'miniaturas',
      eyebrow: 'Miradas del entorno',
      titulo: 'Un paisaje que merece protagonismo.',
      texto: 'Una galería amplia para mostrar terreno, accesos, paisaje, fotografías aéreas e identidad visual. Aquí se utilizan imágenes referenciales de estilo hasta disponer de los archivos oficiales del proyecto.',
      fotos: [
        {
          id: 'photo-1500534623283-312aade485b7', respaldo: 'coquimbo', miniatura: '01 / Territorio',
          leyenda: 'Entorno natural / imagen referencial', alt: 'Lomas en paisaje natural, referencial',
          altMiniatura: 'Lomas, fotografía referencial', aria: 'Ver paisaje de lomas',
        },
        {
          id: 'photo-1464822759023-fed622ff2c3b', respaldo: 'coquimbo', miniatura: '02 / Topografía',
          leyenda: 'Topografía del entorno / imagen referencial', alt: 'Montañas, fotografía referencial',
          altMiniatura: 'Paisaje montañoso referencial', aria: 'Ver paisaje montañoso',
        },
        {
          id: 'photo-1500382017468-9049fed747ef', respaldo: 'fields', miniatura: '03 / Entorno',
          leyenda: 'Paisaje del valle / imagen referencial', alt: 'Campos, imagen ilustrativa',
          altMiniatura: 'Paisaje de campos referencial', aria: 'Ver panorama natural',
        },
      ],
      nota: 'Fotografías ilustrativas, no corresponden necesariamente al proyecto Lomas de Lambert. Sustituir por la galería oficial antes de publicar.',
    },
    atributos: {
      eyebrow: 'Territorio y conectividad',
      titulo: 'Los atributos que definen su localización.',
      texto: 'Presentamos las características del proyecto de forma breve y clara, priorizando el análisis territorial y la experiencia del visitante.',
      items: [
        { titulo: 'Acceso pavimentado', texto: 'La ficha original señala que al pueblo de Lambert se accede por un camino totalmente pavimentado.' },
        { titulo: 'Conexión con La Serena', texto: 'El loteo se ubica a 22 kilómetros de la ciudad, de acuerdo con la información publicada por Polz.' },
        { titulo: 'Equipamiento local', texto: 'En el entorno del pueblo se mencionan servicios básicos comunitarios como posta, colegio, comercios e iglesias.' },
      ],
    },
    ubicacion: {
      titulo: 'Lambert, en el entorno de La Serena.',
      parrafos: [
        'El poblado de Lambert pertenece al territorio de la Región de Coquimbo. El proyecto se sitúa a su costado, en un valle conectado por carretera con La Serena.',
        'La información geográfica publicada señala una distancia aproximada de 22 kilómetros. Para la versión definitiva se recomienda integrar un mapa validado con la ubicación específica del loteo.',
      ],
      boton: { texto: 'Explorar Lambert en Maps ↗', href: 'https://www.google.com/maps/search/?api=1&query=Lambert%2C%20La%20Serena%2C%20Chile' },
      chip: null,
      pueblo: 'Lambert',
      ciudad: 'La Serena ↗',
      aria: 'Esquema ilustrativo de ubicación, no es un mapa a escala',
      nota: 'Esquema conceptual · No representa coordenadas exactas ni distancias a escala.',
    },
    video: {
      titulo: 'Una vista complementaria del proyecto.',
      texto: 'El sitio actual contiene un video titulado “lambert V10”. En la versión definitiva este módulo puede contener una miniatura personalizada y la reproducción integrada del material oficial.',
      url: 'https://www.youtube.com/watch?v=hwOxA9NsfbE',
      enlace: 'Abrir video original en YouTube ↗',
      aria: 'Ver video original de Lomas de Lambert',
    },
    cta: {
      eyebrow: 'Consulta por este proyecto',
      titulo: '¿Quieres conocer más sobre Lomas de Lambert?',
      texto: 'Para detalles, antecedentes del terreno y condiciones vigentes, contacta directamente al equipo de Polz Asociados.',
      secundario: 'Ver más proyectos',
    },
    asunto: 'Consulta sobre Lomas de Lambert',
  },
  {
    slug: 'mirador-del-rey',
    nombre: 'Mirador del Rey',
    tipo: 'Desarrollo habitacional',
    ciudad: 'Puerto Montt',
    region: 'Los Lagos',
    regionNombre: 'Región de Los Lagos',
    foto: 'photo-1448375240586-882707db888b',
    foto2: 'photo-1470770841072-f978cf4d019e',
    respaldo: 'forest',
    alt: 'Fotografía referencial de una ciudad del sur de Chile',
    monograma: 'MR',
    descripcion: '104 hectáreas de terreno urbano en el acceso norte de Puerto Montt, en el corredor que conecta con Puerto Varas.',
    busqueda: 'puerto montt mirador del rey los lagos mirador del rey desarrollo habitacional',
    titular: 'Una nueva escala para el desarrollo urbano del sur.',
    parrafos: [
      'En el límite norte de Puerto Montt, junto a la carretera que conecta con Puerto Varas, se emplaza el proyecto habitacional Mirador del Rey. Su superficie publicada es de 104 hectáreas de terreno urbano.',
      'La ficha pública señala que se trabajaba en anteproyectos orientados a la factibilidad vial, eléctrica y sanitaria de este desarrollo. También menciona la proximidad del proyecto Alto Volcanes, de Constructora Aconcagua.',
      'La publicación original anunciaba lotes desde 2 hectáreas dirigidos a constructoras, inmobiliarias y fondos de inversión. La disponibilidad, el estado técnico y las condiciones comerciales actuales deben confirmarse directamente con Polz Asociados.',
    ],
    cifras: [
      { valor: '104 ha', texto: 'Superficie publicada' },
      { valor: 'Desde 2 ha', texto: 'Lotes señalados en ficha' },
      { valor: 'Puerto Montt', texto: 'Localización' },
    ],
    atributos: {
      items: [
        { titulo: 'Conexión territorial', texto: 'Localización en el corredor vial hacia Puerto Varas, en el acceso norte de Puerto Montt.' },
        { titulo: 'Factibilidad de servicios', texto: 'La publicación señala estudios de factibilidad vial, eléctrica y sanitaria en desarrollo.' },
        { titulo: 'Escala urbana', texto: 'Terreno urbano presentado para desarrollo habitacional a escala de macroproyecto.' },
      ],
    },
    ubicacion: { detalle: 'Límite norte de Puerto Montt, junto a la vía hacia Puerto Varas.' },
    relacionados: ['talca-habitacional', 'mirador-del-inca'],
  },
  {
    slug: 'parque-real-teno',
    nombre: 'Parque Real',
    tipo: 'Loteo industrial',
    ciudad: 'Teno',
    region: 'Maule',
    regionNombre: 'Región del Maule',
    foto: 'photo-1500382017468-9049fed747ef',
    foto2: 'photo-1487958449943-2429e8be8625',
    respaldo: 'fields',
    alt: 'Vista referencial de paisaje agrícola',
    monograma: 'PR',
    descripcion: 'Loteo industrial de 24 hectáreas al norte de Teno, cerca de la Ruta 5 Sur y el cruce La Montaña.',
    busqueda: 'teno región del maule desarrollo parque real loteo industrial parque real industrial',
    titular: 'Suelo industrial en un corredor estratégico.',
    parrafos: [
      'Parque Real es el loteo industrial descrito por Polz Asociados al norte de la ciudad de Teno, entre la carretera Ruta 5 Sur y el cruce La Montaña.',
      'Con una superficie publicada de 24 hectáreas, el proyecto fue concebido para complementar y prestar servicios al número creciente de grandes empresas instaladas en este entorno estratégico.',
      'Su posicionamiento se vincula a la conectividad y a la actividad productiva del sector. Los antecedentes técnicos y comerciales vigentes deben verificarse con Polz Asociados.',
    ],
    cifras: [
      { valor: '24 ha', texto: 'Superficie publicada' },
      { valor: 'Industrial', texto: 'Uso descrito' },
      { valor: 'Teno', texto: 'Localización' },
    ],
    atributos: {
      items: [
        { titulo: 'Conexión vial', texto: 'Emplazamiento descrito entre la Ruta 5 Sur y el cruce La Montaña.' },
        { titulo: 'Vocación productiva', texto: 'Loteo destinado a servicios y actividades de apoyo a empresas del entorno.' },
        { titulo: 'Escala gestionable', texto: '24 hectáreas, según la presentación original del proyecto.' },
      ],
    },
    ubicacion: { detalle: 'Sector norte de Teno, entre Ruta 5 Sur y cruce La Montaña.' },
    relacionados: ['talca-habitacional', 'lomas-del-noviciado'],
  },
  {
    slug: 'barrio-golf',
    nombre: 'Barrio Golf',
    tipo: 'Suelo con proyección urbana',
    ciudad: 'Los Ángeles',
    region: 'Biobío',
    regionNombre: 'Región del Biobío',
    foto: 'photo-1470770841072-f978cf4d019e',
    foto2: 'photo-1448375240586-882707db888b',
    respaldo: 'forest',
    alt: 'Vista paisajística referencial de laguna y vegetación',
    monograma: 'BG',
    descripcion: '70 hectáreas al norte de Los Ángeles, junto a una laguna y áreas de vegetación.',
    busqueda: 'los angeles barrio golf región biobio laguna barrio golf suelo con proyección urbana',
    titular: 'Paisaje, territorio y proyección de plusvalía.',
    parrafos: [
      'El proyecto Barrio Golf se emplaza en el límite norte de la ciudad de Los Ángeles, sobre un terreno de 70 hectáreas, descrito por Polz Asociados como un entorno rodeado por una laguna y abundante vegetación.',
      'Según la ficha original, el terreno estaba considerado en la zona de crecimiento del futuro Plan Regulador de Los Ángeles, bajo la categoría de Zona de Expansión Urbana.',
      'La propuesta de plusvalía descrita estaba condicionada al término de la tramitación del instrumento de planificación territorial. Esta situación normativa debe actualizarse y validarse antes de publicar información comercial.',
    ],
    cifras: [
      { valor: '70 ha', texto: 'Superficie publicada' },
      { valor: 'Expansión', texto: 'Proyección normativa descrita' },
      { valor: 'Los Ángeles', texto: 'Localización' },
    ],
    atributos: {
      items: [
        { titulo: 'Contexto natural', texto: 'Terreno descrito junto a una laguna y vegetación.' },
        { titulo: 'Proyección territorial', texto: 'La ficha original vincula su potencial a la planificación de expansión urbana.' },
        { titulo: 'Revisión normativa', texto: 'La situación del Plan Regulador requiere confirmación actualizada.' },
      ],
    },
    ubicacion: { detalle: 'Límite norte de la ciudad de Los Ángeles.' },
    relacionados: ['mirador-del-rey', 'parque-real-teno'],
  },
  {
    slug: 'talca-habitacional',
    nombre: 'Desarrollo Talca',
    tipo: 'Desarrollo habitacional',
    ciudad: 'Talca',
    region: 'Maule',
    regionNombre: 'Región del Maule',
    foto: 'photo-1480714378408-67cf0d13bc1b',
    foto2: 'photo-1497366811353-6870744d04b2',
    respaldo: 'urban',
    alt: 'Vista referencial de entorno urbano',
    monograma: 'TA',
    descripcion: '150 hectáreas urbanas en el norte de Talca, orientadas a proyectos habitacionales.',
    busqueda: 'talca proyecto habitacional maule 150 hectáreas desarrollo talca desarrollo habitacional',
    titular: 'Una reserva urbana conectada a la Ruta 5 Sur.',
    parrafos: [
      'Este proyecto contempla 150 hectáreas de suelo urbano en el sector norte de Talca. La presentación original lo describe como un desarrollo habitacional en etapa de estudio y planificación territorial.',
      'Polz Asociados indicaba que el objetivo era comercializar macrolotes destinados a futuros proyectos habitacionales. El terreno dispone, según la ficha original, de acceso directo desde la Ruta 5 Sur y tendido eléctrico.',
      'La misma publicación menciona 80 litros por segundo de aguas subterráneas como antecedente para una eventual solución sanitaria. Esta cifra, al igual que las condiciones del proyecto, requiere verificación técnica y comercial actualizada.',
    ],
    cifras: [
      { valor: '150 ha', texto: 'Superficie urbana publicada' },
      { valor: 'Ruta 5 Sur', texto: 'Acceso informado' },
      { valor: 'Talca', texto: 'Localización' },
    ],
    atributos: {
      items: [
        { titulo: 'Conectividad', texto: 'Acceso directo desde la Ruta 5 Sur, de acuerdo con la presentación publicada.' },
        { titulo: 'Planificación', texto: 'Terreno descrito en etapa de estudio territorial para macrolotes habitacionales.' },
        { titulo: 'Servicios', texto: 'Tendido eléctrico y recurso hídrico reportados en la ficha original; verificar vigencia.' },
      ],
    },
    ubicacion: { detalle: 'Sector norte de Talca, con conexión a Ruta 5 Sur.' },
    relacionados: ['mirador-del-rey', 'parque-real-teno'],
  },
  {
    slug: 'lomas-del-noviciado',
    nombre: 'Lomas del Noviciado',
    tipo: 'Loteo industrial',
    ciudad: 'Pudahuel',
    region: 'Metropolitana',
    regionNombre: 'Región Metropolitana',
    foto: 'photo-1497366754035-f200968a6e72',
    foto2: 'photo-1486406146926-c627a92ad1ab',
    respaldo: 'industrial',
    alt: 'Imagen de arquitectura industrial referencial',
    monograma: 'LN',
    descripcion: '68 hectáreas de lomaje suave destinadas a un loteo industrial en formación.',
    busqueda: 'pudahuel region metropolitana lomas noviciado industrial lomas del noviciado loteo industrial',
    titular: 'Territorio industrial en el poniente de Santiago.',
    parrafos: [
      'Lomas del Noviciado es un loteo industrial localizado en Pudahuel, al poniente del camino a Noviciado y en el entorno de los primeros faldeos de la cordillera de la Costa.',
      'La descripción publicada por Polz Asociados indica una superficie de 68 hectáreas de lomaje suave y lo identifica como un loteo industrial en formación.',
      'Para una presentación comercial definitiva se recomienda confirmar la situación urbanística del terreno, la etapa actual del loteo y sus condiciones de disponibilidad.',
    ],
    cifras: [
      { valor: '68 ha', texto: 'Superficie publicada' },
      { valor: 'Industrial', texto: 'Destino descrito' },
      { valor: 'Pudahuel', texto: 'Comuna' },
    ],
    atributos: {
      items: [
        { titulo: 'Suelo industrial', texto: 'Proyecto publicado con vocación de loteo industrial.' },
        { titulo: 'Entorno territorial', texto: 'Faldeos de cerros en el sector poniente de Santiago.' },
        { titulo: 'Localización', texto: 'Emplazamiento en Pudahuel, junto al camino a Noviciado.' },
      ],
    },
    ubicacion: { detalle: 'Pudahuel, al poniente del camino a Noviciado.' },
    relacionados: ['parque-real-teno', 'mirador-del-rey'],
  },
  {
    slug: 'mirador-del-inca',
    nombre: 'Mirador del Inca',
    tipo: 'Desarrollo habitacional',
    ciudad: 'Ovalle',
    region: 'Coquimbo',
    regionNombre: 'Región de Coquimbo',
    foto: 'photo-1464822759023-fed622ff2c3b',
    foto2: 'photo-1500534623283-312aade485b7',
    respaldo: 'coquimbo',
    alt: 'Fotografía paisajística de valle, referencial',
    monograma: 'MI',
    descripcion: '44 hectáreas urbanas, subdivididas en cinco macrolotes en el sector de Tuqui, al norte de Ovalle.',
    busqueda: 'ovalle mirador del inca tuqui coquimbo mirador del inca desarrollo habitacional',
    titular: 'Macrolotes urbanos con conectividad estratégica.',
    parrafos: [
      'La primera etapa del proyecto habitacional Mirador del Inca comprende 44 hectáreas de terreno urbano, subdivididas en cinco macrolotes con superficies desde 7 a 9 hectáreas, según la ficha publicada.',
      'Se encuentra al norte de Ovalle, en el sector alto de Tuqui, en las proximidades del casino y de la carretera hacia La Serena.',
      'El proyecto dispone, según la descripción original, de acceso directo a la avenida Circunvalación, una vía estructurante de la ciudad. Las superficies definitivas y condiciones de desarrollo deben validarse con el titular.',
    ],
    cifras: [
      { valor: '44 ha', texto: 'Superficie publicada' },
      { valor: '5', texto: 'Macrolotes' },
      { valor: '7–9 ha', texto: 'Superficies indicadas' },
    ],
    atributos: {
      items: [
        { titulo: 'Macrolotes', texto: 'Cinco unidades territoriales de 7 a 9 hectáreas según la ficha original.' },
        { titulo: 'Conectividad', texto: 'Acceso directo a avenida Circunvalación, vialidad estructurante.' },
        { titulo: 'Localización', texto: 'Sector alto de Tuqui, al norte de Ovalle.' },
      ],
    },
    ubicacion: { detalle: 'Sector alto de Tuqui, al norte de Ovalle.' },
    relacionados: ['mirador-del-rey', 'talca-habitacional'],
  },
  {
    slug: 'ciudad-industrial-talca',
    nombre: 'Ciudad Industrial Talca',
    tipo: 'Desarrollo industrial',
    ciudad: 'Talca',
    region: 'Maule',
    regionNombre: 'Región del Maule',
    foto: 'photo-1487958449943-2429e8be8625',
    foto2: 'photo-1497366754035-f200968a6e72',
    respaldo: 'industrial',
    alt: 'Fotografía urbana referencial',
    monograma: 'CI',
    descripcion: '30 hectáreas de uso industrial al norte de Talca, cerca del aeródromo de Panguilemu.',
    busqueda: 'talca segundo proyecto desarrollo región maule ciudad industrial talca desarrollo industrial ciudad industrial talca 30 hectareas',
    titular: 'Suelo industrial conectado al centro del país.',
    parrafos: [
      'Ciudad Industrial Talca corresponde a un proyecto de 30 hectáreas de uso exclusivo industrial ubicado en el límite norte de Talca, al poniente del aeródromo Panguilemu.',
      'La ficha publicada por Polz Asociados menciona macrolotes industriales de entre 1 y 5 hectáreas, líneas de abastecimiento eléctrico de mediana y alta tensión y acceso directo desde Ruta 5 Sur.',
      'La disponibilidad para venta descrita en el sitio original no constituye confirmación de disponibilidad actual. Condiciones de comercialización, factibilidades y antecedentes legales deben actualizarse.',
    ],
    cifras: [
      { valor: '30 ha', texto: 'Superficie publicada' },
      { valor: '1–5 ha', texto: 'Macrolotes señalados' },
      { valor: 'Industrial', texto: 'Uso informado' },
    ],
    atributos: {
      items: [
        { titulo: 'Acceso vial', texto: 'Conexión directa a Ruta 5 Sur, según información publicada.' },
        { titulo: 'Electricidad', texto: 'La ficha menciona líneas de media y alta tensión.' },
        { titulo: 'Macrolotes', texto: 'Subdivisión comercial originalmente descrita de 1 a 5 hectáreas.' },
      ],
    },
    ubicacion: { detalle: 'Sector norte de Talca, al poniente del aeródromo Panguilemu.' },
    relacionados: ['parque-real-teno', 'talca-habitacional'],
  },
];

// Lo que comparten las fichas estándar; Lomas de Lambert pisa casi todo.
export function ficha(slug) {
  const p = PROYECTOS.find((x) => x.slug === slug);
  if (!p) return null;
  const lugar = `${p.ciudad}, ${p.regionNombre}`;
  return {
    lema: p.tipo,
    subtitulo: p.descripcion,
    accion: { texto: 'Volver al portafolio', href: URL_PROYECTOS },
    kicker: `${p.ciudad} / ${p.regionNombre}`,
    nota: DISCLAIMER,
    secciones: ['atributos', 'galeria', 'ubicacion', 'relacionados'],
    asunto: `Consulta por ${p.nombre}`,
    ...p,
    titulo: p.titulo || `${p.nombre}<em>.</em>`,
    identidad: p.identidad || {
      nota: 'Ficha de proyecto · Polz Asociados',
      etiqueta: 'Datos publicados',
      texto: p.descripcion,
      stats: p.cifras.slice(0, 2),
    },
    atributos: {
      eyebrow: 'Enfoque territorial',
      titulo: 'Un desarrollo con características propias.',
      texto: 'Presentamos sus atributos más relevantes con una lectura clara, priorizando el valor territorial y los antecedentes que sustentan las decisiones.',
      ...p.atributos,
    },
    galeria: p.galeria || {
      modo: 'doble',
      eyebrow: 'Material visual',
      titulo: 'Una mirada al entorno del proyecto.',
      texto: 'Espacio diseñado para recibir fotografías, planos de loteo y registros oficiales. Por ahora se utilizan imágenes referenciales, no fotografías verificadas del predio.',
      fotos: [
        { src: foto(p.foto, 1900, 82), alt: 'Fotografía paisajística referencial del tipo de entorno', leyenda: '01 / Paisaje referencial · No es el terreno real' },
        { src: foto(p.foto2, 1100), alt: 'Fotografía de referencia ilustrativa', leyenda: '02 / Referencia visual · No es el proyecto real' },
      ],
    },
    ubicacion: p.ubicacion.titulo ? p.ubicacion : {
      titulo: `${lugar}.`,
      parrafos: [p.ubicacion.detalle, CONCEPTUAL],
      boton: null,
      chip: lugar,
      pueblo: p.ciudad,
      ciudad: null,
      aria: 'Representación conceptual, no mapa de ubicación exacta',
      nota: 'Referencia territorial ilustrativa · No representa coordenadas ni límites prediales.',
    },
    relacionados: (p.relacionados || []).map((s) => PROYECTOS.find((x) => x.slug === s)),
    cta: p.cta || {
      eyebrow: `Contacto / ${p.nombre}`,
      titulo: 'Conversemos sobre este proyecto.',
      texto: 'Solicita información para verificar antecedentes, condiciones y disponibilidad actual directamente con el equipo de Polz Asociados.',
      secundario: 'Todos los proyectos',
    },
  };
}
